import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';


@Injectable({
  providedIn: 'root'
})
export class FcmService {

  constructor(
    private userService: AuthService,
    private router: Router
  ) { }

  initPush() {
    if(Capacitor.getPlatform() !== 'web') {
      // Initialize Push Notifications
      this.registerPush();
    }
  }

  private async registerPush() {
    const { PushNotifications } = await import('@capacitor/push-notifications');
    const { App } = await import('@capacitor/app');

    //Request permission to use push notifications
    PushNotifications.requestPermissions().then(result => {

      if (result.receive === 'granted') {
        // Register for push notifications
        PushNotifications.register();
      } else {
        console.error('Push notification permission denied');
      }
    });

    // Listen for registration success
    PushNotifications.addListener('registration', (token) => {
      this.userService.savePushToken(token.value).subscribe((response) => {
        
      }, (error) => {
        console.error('Error saving push token: ', error);
      }
      );
      console.log('Push registration success, token: ', token.value);
    });

    // Listen for registration error
    PushNotifications.addListener('registrationError', (error) => {
      console.error('Push registration error: ', error);
    });

    // Listen for incoming notifications (when app is in foreground)
    PushNotifications.addListener('pushNotificationReceived', (notification) => {
      console.log('Push notification received: ', notification);
      // Handle notification when app is in foreground
      this.handleNotification(notification);
    });

    // Listen for notification actions (when user taps notification)
    PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
      console.log('Push notification action performed: ', action);
      // Handle notification tap
      this.handleNotificationTap(action.notification);
    });

    // Handle app state changes
    App.addListener('appStateChange', (state) => {
      console.log('App state changed: ', state.isActive);
    });
  }

  private handleNotification(notification: any) {
    // Handle notification when app is in foreground
    // You can show a toast or alert here
    console.log('Notification received in foreground:', notification);
    
    // Extract data from notification
    const data = notification.data || {};
    this.processNotificationData(data);
  }

  private handleNotificationTap(notification: any) {
    // Handle notification tap - navigate to appropriate page
    console.log('Notification tapped:', notification);
    
    // Extract data from notification
    // Capacitor may structure data differently
    const data = notification.data || notification.additionalData || {};
    this.processNotificationData(data);
  }

  private processNotificationData(data: any) {
    // Process notification data and navigate accordingly
    if (data.type === 'department_message' && data.message_id) {
      // Navigate to department message detail page
      const messageId = data.message_id;
      this.router.navigate(['/department-messages/detail', messageId]).catch(err => {
        console.error('Navigation error:', err);
        // Fallback to list page if detail fails
        this.router.navigate(['/department-messages/list']);
      });
    } else {
      // Default navigation or handle other notification types
      console.log('Unknown notification type or missing data:', data);
    }
  }

}
